import {
  ADD_BENEFITS,
  FETCHING_BENEFITS,
  FETCHED_BENEFITS,
  CLEAR_BENEFITS_CONTEXT,
  CLEAR_ALL,
} from '../constants';

interface BenefitsState {
  list: Record<string, any[]>;   // keyed by state name, e.g. { 'California': [...] }
  context: Record<string, Record<string, any> | null>;
  fetched: Record<string, boolean>;
  fetching: boolean;
}

const initialState: BenefitsState = {
  list: {},
  context: {},
  fetched: {},
  fetching: false,
};

const benefitsReducer = (
  state = initialState,
  { type, payload }: { type: string; payload?: any }
): BenefitsState => {
  switch (type) {
    case FETCHING_BENEFITS:
      return { ...state, fetching: Boolean(payload) };
    case ADD_BENEFITS:
      return {
        ...state,
        list: { ...state.list, [payload.cacheKey]: payload.list },
        context: { ...state.context, [payload.cacheKey]: payload.context ?? null },
      };
    case FETCHED_BENEFITS:
      return {
        ...state,
        fetched: { ...state.fetched, [payload.cacheKey]: true },
      };
    case CLEAR_BENEFITS_CONTEXT: {
      if (!(payload.cacheKey in state.context)) return state;
      const context = { ...state.context };
      delete context[payload.cacheKey];
      return { ...state, context };
      }
    case CLEAR_ALL:
      return { ...initialState };
    default:
      return state;
  }
};

export default benefitsReducer;
